import React, { useState } from "react";
import "./AccordionSidebar.css";
import "../components/table.css";
import "./academic-portal.css";
import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";

// Year-wise data for Advisory Committee
const advisoryCommitteeDataByYear = {
    "A.Y. 2026-27": [
        { no: 1, name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, name: "Ms. Anamika Dhawan", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Mayur Pawar", designation: "Placement Co-Ordinator" },
        { no: 5, name: "Mr. Arvind Kumar Ram", designation: "Officiating Lab Asst." }
    ],
    "A.Y. 2025-26": [
        { no: 1, name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, name: "Ms. Anamika Dhawan", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Mayur Pawar", designation: "Placement Co-Ordinator" },
        { no: 5, name: "Mr. Arvind Kumar", designation: "Officiating Lab Asst." },
    ],
    "A.Y. 2024-25": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Ms. Anamika Dhawan", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Mayur Pawar", designation: "Placement Co-Ordinator" },
        { no: 5, name: "Mr. Arvind Kumar", designation: "Officiating Lab Asst." },
    ],
    "A.Y. 2023-24": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Ms. Anamika Dhawan", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Mr. Mayur Pawar", designation: "DTP Operator" },
        { no: 5, name: "Mr. Arvind Kumar", designation: "Officiating Lab Asst." },
    ],
    "A.Y. 2022-23": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Dr. Megha Mudholkar", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Mr. Mayur Pawar", designation: "DTP Operator" },
        { no: 5, name: "Mr. Arvind Kumar", designation: "Lab Attendant" },
    ],
    "A.Y. 2021-22": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Dr. Megha Mudholkar", designation: "Asst. Professor" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Ms. Ashwini Deore", designation: "Lab Assistant" },
        { no: 5, name: "Mr. Arvind Kumar", designation: "Lab Attendant" },
    ],
    "A.Y. 2020-21": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 3, name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 4, name: "Mr. Shailesh Sharma", designation: "Sr. Clerk" },
        { no: 5, name: "Mr. Prashant Satam", designation: "Sr. Clerk" },
    ],
    "A.Y. 2019-20": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 3, name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 4, name: "Mr. Shailesh Sharma", designation: "Sr. Clerk" },
        { no: 5, name: "Mr. Prashant Satam", designation: "Sr. Clerk" },
    ],
};

const minorityCellDataByYear = {
    "A.Y. 2026-27": [
        { no: 1, name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Shoaib Gayasuddin Ansari", designation: "Student" },
        { no: 5, name: "Mr. Huzaifa Shamim Mohammad", designation: "Student" },
        { no: 6, name: "Mr. John Solaimuthu Joseph", designation: "Student" },
        { no: 7, name: "Mr. Areeb Ziaullah Khan", designation: "Student" },
        { no: 8, name: "Ms. Qadeer Raza Khan", designation: "Student" },
        { no: 9, name: "Ms. Shaziya Shahzade Khan", designation: "Student" },
        { no: 10, name: "Mr. Shezaan Sageer Khan", designation: "Student" },
        { no: 11, name: "Mr. Jobin Richard Pereira", designation: "Student" }
    ],
    "A.Y. 2025-26": [
        { no: 1, name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Imran Karim Khan", designation: "Student" },
        { no: 5, name: "Mr. Ramsa Khalid Ansari", designation: "Student" },
        { no: 6, name: "Mr. Umar Farooq Khan", designation: "Student" },
        { no: 7, name: "Mr. Mohammed Samin Ansari", designation: "Student" },
        { no: 8, name: "Ms. Noor Fatima Hashmi", designation: "Student" },
        { no: 9, name: "Ms. Aarjoo Faiz Khan", designation: "Student" },
        { no: 10, name: "Ms. Teena Sheeja Thomas", designation: "Student" },
        { no: 11, name: "Mr. Royal Albert Rodrigues", designation: "Student" }
    ],
    "A.Y. 2024-25": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 4, name: "Mr. Ansari Aman Asrar", designation: "Student (2nd Year)" },
        { no: 5, name: "Mr. Dennis Aryan John", designation: "Student (2nd Year)" },
        { no: 6, name: "Ms. Fernandes Josephin Patrick", designation: "Student (2nd Year)" }
    ],
    "A.Y. 2023-24": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Ms. Ariba Parvez Akhtar", designation: "Student (2nd Year)" },
        { no: 5, name: "Mr. Jose Joy Chacko", designation: "Student (2nd Year)" },
        { no: 6, name: "Mr. Clinton John Solaimuthu", designation: "Student (2nd Year)" }
    ],
    "A.Y. 2022-23": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Dsouza Soney Xavier", designation: "Student (2nd Year)" },
        { no: 5, name: "Gudhka Meet Girish", designation: "Student (2nd Year)" },
        { no: 6, name: "Shaikh Mohammed Shahrukh Shehzaad", designation: "Student (2nd Year)" }
    ],
    "A.Y. 2021-22": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 4, name: "Mr. Khan Mohd Amir Lukman", designation: "Student (2nd Year)" },
        { no: 5, name: "Ms. Rimsha Siddiqui", designation: "Student (1st Year)" }
    ],
    "A.Y. 2020-21": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Sr. Clerk" },
        { no: 4, name: "Ms. Shreya Mahendra Mehta", designation: "Student (3rd Year)" },
        { no: 5, name: "Mr. Khan Mohd Amir Lukman", designation: "Student (1st Year)" }
    ],
    "A.Y. 2019-20": [
        { no: 1, name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, name: "Mr. Brijesh Pandey", designation: "Asst. Professor & TPO" },
        { no: 3, name: "Mr. Shailesh Sharma", designation: "Sr. Clerk" },
        { no: 4, name: "Mr. Melvin George Mathew", designation: "Student (3rd Year)" },
        { no: 5, name: "Ms. Shreya Mahendra Mehta", designation: "Student (2nd Year)" }
    ]
};
const grievanceCommitteeDataByYear = {
    "A.Y. 2026-27": [
        { "no": 1, "position": "Chairperson", "name": "Dr. Pravin Gundalwar", "designation": "Director" },
        { "no": 2, "position": "Member Secretary", "name": "Ms. Rupali Jadhav", "designation": "Assistant Professor & Deputy HOD-MCA" },
        { "no": 3, "position": "Member", "name": "Ms. Kinjal Doshi", "designation": "Assistant Professor HOD-MCA" },
        { "no": 4, "position": "VC Nominee", "name": "Dr. Rohini Kelkar", "designation": "Principal, Vidyalankar School of Information Technology" }
    ],
    "A.Y. 2025-26": [
        { no: 1, position: "Chairman", name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Rupali Jadhav", designation: "Assistant Professor, IQAC Coordinator" },
        { no: 3, position: "Member", name: "Ms. Kinjal Doshi", designation: "Assistant Professor" }
    ],
    "A.Y. 2024-25": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & TPO" },
        { no: 3, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor & HOD-ACA" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 5, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" }
    ],
    "A.Y. 2023-24": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & TPO" },
        { no: 3, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor & HOD-ACA" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
    ],
    "A.Y. 2022-23": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & TPO" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" }
    ],
    "A.Y. 2021-22": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & TPO" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" }
    ],
    "A.Y. 2020-21": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & TPO" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" }
    ],
    "A.Y. 2019-20": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & MR" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Senior Clerk" }
    ],
    "A.Y. 2018-19": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & MR" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Senior Clerk" }
    ],
    "A.Y. 2017-18": [
        { no: 1, position: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Ombudsman", name: "Ms. Sonu Gupta", designation: "Assistant Professor & MR" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Assistant Professor" },
        { no: 4, position: "Member", name: "Ms. Rashmi Vipat", designation: "Assistant Professor & Exam In-charge" },
        { no: 6, position: "Member", name: "Mr. Shailesh Sharma", designation: "Senior Clerk" }
    ],
};

const internalCompliantCommitteeDataByYear = {
    "A.Y. 2026-27": [
        { no: 1, position: "Presiding Officer", name: "Dr. Ashwini Renavikar", designation: "Professor, R&D" },
        { no: 2, position: "Member", name: "Ms. Kinjal Doshi", designation: "Asst. Prof. & HOD-MCA" },
        { no: 3, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Prof. & Deputy HOD-MCA" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Raj Shirke", designation: "Student" },
        { no: 7, position: "Member", name: "Mr. Pranav Vaidya", designation: "Student" },
        { no: 8, position: "Member", name: "Mr. Ajay Yadav", designation: "Student" },
        { no: 9, position: "Non-Government Organization", name: "Dr. Sangeeta Shirname", designation: "Inseed NGO Member" }
    ],
    "A.Y. 2025-26": [
        { no: 1, position: "Presiding Officer", name: "Dr. Ashwini Renavikar", designation: "Professor & HOD-MCA Integrated" },
        { no: 2, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Asst. Prof. & HOD-ACA" },
        { no: 3, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Prof. & IQAC Coordinator" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Ayush Dubey", designation: "Student" },
        { no: 7, position: "Member", name: "Ms. Anuja Shinde", designation: "Student" },
        { no: 8, position: "Member", name: "Mr. Vikas Yadav", designation: "Student" },
        { no: 9, position: "Non-Government Organization", name: "Dr. Sangeeta Shirname", designation: "Inseed NGO Member" }
    ],
    "A.Y. 2024-25": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Assistant Professor & HOD-ACA, TIMSCDR" },
        { no: 3, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Mohd. Afzal Nandolia", designation: "Student (2nd year)" },
        { no: 7, position: "Member", name: "Ms. Fernandes Josephine", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Mr. Gupta Omkar", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed NGO)" }
    ],
    "A.Y. 2023-24": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Assistant Professor & HOD-ACA, TIMSCDR" },
        { no: 3, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Ms. Priya Singh", designation: "Student (2nd year)" },
        { no: 7, position: "Member", name: "Ms. Ariba Akhtar", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Mr. Sandeep Yadav", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed NGO)" }
    ],
    "A.Y. 2022-23": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Ms. Verma Swati Gopal", designation: "Student (2nd year)" },
        { no: 7, position: "Member", name: "Mr. Vishwakarma Sandeep Ramesh", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Ms. Harshika Naik", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ],
    "A.Y. 2021-22": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Manthan Mirgal", designation: "Student (3rd year)" },
        { no: 7, position: "Member", name: "Ms. Nisha Maurya", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Mr. Malav Shah", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ],
    "A.Y. 2020-21": [
        { no: 1, position: "Presiding Officer", name: "Ms. Aprajita Singh", designation: "Deputy Director" },
        { no: 2, position: "Member", name: "Ms. Sreeja S. S.", designation: "Asst. Professor, HOD-ACA" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Rakesh Kale", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Manthan Mirgal", designation: "Student (2nd year)" },
        { no: 7, position: "Member", name: "Ms. Ana Gadala", designation: "Student (2nd year)" },
        { no: 8, position: "Member", name: "Mr. Rahul Kewat", designation: "Student (3rd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ],
    "A.Y. 2019-20": [
        { no: 1, position: "Presiding Officer", name: "Ms. Aprajita Singh", designation: "Asst. Prof., Deputy Director, HOD-ACA" },
        { no: 2, position: "Member", name: "Ms. Sreeja S. S.", designation: "Asst. Professor" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Rakesh Kale", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Rishabh Singh", designation: "Student (3rd year)" },
        { no: 7, position: "Member", name: "Ms. Anuja Naik", designation: "Student (3rd year)" },
        { no: 8, position: "Member", name: "Mr. Rahul Kewat", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ],
    "A.Y. 2018-19": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Ms. Charmi Shah", designation: "Student (3rd year)" },
        { no: 7, position: "Member", name: "Ms. Janice Fernandes", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Mr. Subheesh Sukumaran", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ],
    "A.Y. 2017-18": [
        { no: 1, position: "Presiding Officer", name: "Ms. Rashmi Vipat", designation: "Asst. Professor & Exam In charge" },
        { no: 2, position: "Member", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 3, position: "Member", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor" },
        { no: 4, position: "Member", name: "Mr. Shailesh Sharma", designation: "Head Clerk" },
        { no: 5, position: "Member", name: "Ms. Pritam Rane", designation: "Sr. Clerk" },
        { no: 6, position: "Member", name: "Mr. Keith Machado", designation: "Student (3rd year)" },
        { no: 7, position: "Member", name: "Ms. Sayali Gharat", designation: "Student (2nd Year)" },
        { no: 8, position: "Member", name: "Mr. Charmi Shah", designation: "Student (2nd year)" },
        { no: 9, position: "Non-Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" }
    ]
};

const antiRaggingCommitteeDataByYear = {
    "A.Y. 2026-27": [
        { no: 1, position: "Head of the Institute", name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Narayan Patil", designation: "Head Constable, Mumbai Police" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor & IQAC Co-ordinator" },
        { no: 6, position: "Faculty Members", name: "Ms. Kinjal Doshi", designation: "Asst. Professor & HOD-ACA" },
        { no: 7, position: "Parent", name: "Mr. Sanjay Upadhyay", designation: "Bank Manager" },
        { no: 8, position: "Parent", name: "Mr. Ericc Rana", designation: "Business" },
        { no: 9, position: "Students", name: "Ms. Riya Upadhyay", designation: "Student (MCA)" },
        { no: 10, position: "Students", name: "Mr. Daneshh Rana", designation: "Student (IMCA)" },
        { no: 11, position: "Hostel", name: "Mr. Alok Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non-Teaching Staff", name: "Mr. Shailesh Sharma", designation: "Office Superintendent" },
        { no: 13, position: "Non-Teaching Staff", name: "Mr. Prashant Satam", designation: "Senior Clerk" }
    ],
    "A.Y. 2025-26": [
        { no: 1, position: "Head of the Institute", name: "Dr. Pravin Gundalwar", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Narayan Patil", designation: "Head Constable, Mumbai Police" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor & IQAC Co-Ordinator" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor & HOD-ACA" },
        { no: 7, position: "Parents", name: "Mr. Ramkrishna Sawant", designation: "Retd. Assistant Sub Inspector" },
        { no: 8, position: "Parents", name: "Mr. Ashok Salunkhe", designation: "Creative Manager, Ascent Meditech" },
        { no: 9, position: "Students", name: "Mr. Vikas Shelar", designation: "Student" },
        { no: 10, position: "Students", name: "Ms. Sanjana Redkar", designation: "student" },
        { no: 11, position: "Hostel", name: "Mr. Alok Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Office Superintendent (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2024-25": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Narayan Patil", designation: "Head Constable, Mumbai Police" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Vijay Chaudhari", designation: "Retd. Assistant Sub Inspector" },
        { no: 8, position: "Member", name: "Mr. Ashok Salunkhe", designation: "Creative Manager, Ascent Meditech" },
        { no: 9, position: "Students", name: "Mr. Nikhil Chaudhari", designation: "2nd Year student" },
        { no: 10, position: "Member", name: "Ms. Riddhi Kesharwani", designation: "2nd Year student" },
        { no: 11, position: "Hostel", name: "Mr. Alok Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Member", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2023-24": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Narayan Patil", designation: "Head Constable, Mumbai Police" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Dr. Sangeeta Shirname", designation: "Socialist (Inseed NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Member", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Vijay Chaudhari", designation: "Retd. Assistant Sub Inspector" },
        { no: 8, position: "Member", name: "Mr. Ashok Salunkhe", designation: "Creative Manager, Ascent Meditech" },
        { no: 9, position: "Students", name: "Mr. Nikhil Chaudhari", designation: "2nd Year student" },
        { no: 10, position: "Member", name: "Ms. Riddhi Kesharwani", designation: "2nd Year student" },
        { no: 11, position: "Hostel", name: "Mr. Alok Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Member", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2022-23": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Narayan Patil", designation: "Head Constable, Mumbai Police" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Rohini Kulkarni", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Ramkrishna Sawant", designation: "Retd. Assistant Sub Inspector" },
        { no: 8, position: "Parents", name: "Mr. Ashok Salunkhe", designation: "Creative Manager, Ascent Meditech" },
        { no: 9, position: "Students", name: "Maruf Zaheen Basharat", designation: "2nd Year student" },
        { no: 10, position: "Students", name: "Mhaske Shruti Subhash", designation: "2nd Year student" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2021-22": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Machindranath Chavan", designation: "Sr. Police Inspector (Crime Branch)" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Snehali Vaidya", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Hemant Kale", designation: "Mumbai Police Inspector" },
        { no: 8, position: "Parents", name: "Ms. Sunetra Prabhu", designation: "Service (MTNL)" },
        { no: 9, position: "Students", name: "Mr. Archin Joshi", designation: "2nd Year student" },
        { no: 10, position: "Students", name: "Mr. Anurag Singh", designation: "3rd Year student" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2020-21": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Machindranath Chavan", designation: "Sr. Police Inspector (Crime Branch)" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Snehali Vaidya", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Hemant Kale", designation: "Mumbai Police Inspector" },
        { no: 8, position: "Parents", name: "Ms. Sunetra Prabhu", designation: "Service (MTNL)" },
        { no: 9, position: "Students", name: "Ms. Tanvi Chavan", designation: "2nd Year student" },
        { no: 10, position: "Students", name: "Mr. Mahesh Shinde", designation: "2nd Year student" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2019-20": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Machindranath Chavan", designation: "Sr. Police Inspector (Crime Branch)" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Snehali Vaidya", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Hemant Kale", designation: "Mumbai Police Inspector" },
        { no: 8, position: "Parents", name: "Ms. Sunetra Prabhu", designation: "Service (MTNL)" },
        { no: 9, position: "Students", name: "Ms. Tanvi Chavan", designation: "1st Year student" },
        { no: 10, position: "Students", name: "Mr. Mahesh Shinde", designation: "1st Year student" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Prashant Satam", designation: "Sr. Clerk" }
    ],
    "A.Y. 2018-19": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Machindranath Chavan", designation: "Sr. Police Inspector (Crime Branch)" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Snehali Vaidya", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Hemant Kale", designation: "Mumbai Police Inspector" },
        { no: 8, position: "Parents", name: "Ms. Sunetra Prabhu", designation: "Service (MTNL)" },
        { no: 9, position: "Students", name: "Mr. Rolstan D’souza", designation: "Student (1st year)" },
        { no: 10, position: "Students", name: "Ms. Anuja Naik", designation: "Student (2nd year)" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Rakesh Kale", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Mr. Shailesh Sharma", designation: "Sr. Clerk" }
    ],
    "A.Y. 2017-18": [
        { no: 1, position: "Head of the Institute", name: "Dr. Vinita Gaikwad", designation: "Director" },
        { no: 2, position: "Police Administration", name: "Mr. Machindranath Chavan", designation: "Sr. Police Inspector (Crime Branch)" },
        { no: 3, position: "Local Media", name: "Mr. Wasim Sheikh", designation: "Journalist (HT)" },
        { no: 4, position: "Non Government Organization", name: "Ms. Snehali Vaidya", designation: "Socialist (Swadhar NGO)" },
        { no: 5, position: "Faculty Members", name: "Ms. Rupali Jadhav", designation: "Asst. Professor" },
        { no: 6, position: "Faculty Members", name: "Mr. Shirshendu Maitra", designation: "Asst. Professor" },
        { no: 7, position: "Parents", name: "Mr. Hemant Kale", designation: "Mumbai Police Inspector" },
        { no: 8, position: "Parents", name: "Ms. Sunetra Prabhu", designation: "Service (MTNL)" },
        { no: 9, position: "Students", name: "Ms. Anuja Naik", designation: "Student (1st year)" },
        { no: 10, position: "Students", name: "Ms. Chandni Gupta", designation: "Student (2nd year)" },
        { no: 11, position: "Hostel", name: "Mr. Rajesh Singh", designation: "Hostel Warden" },
        { no: 12, position: "Non – teaching staff", name: "Mr. Rakesh Kale", designation: "Head Clerk (Secretary)" },
        { no: 13, position: "Non – teaching staff", name: "Ms. Shailesh Sharma", designation: "Sr. Clerk" }
    ]
};

const committeeData = [
    {
        title: "Advisory Committee for Equal Opportunity and SC / ST Committee",
        items: [
            "Advisory Committee for Equal Opportunity and SC / ST Committee",
            "Notice of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2025-26)",
            "MOM of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2025-26)",
            "Notice and Circular of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2022-23 to A.Y. 2024-25)",
            "Minutes of Meeting of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2022-23 to A.Y. 2024-25)",
            "Minutes of Meeting of Minority Cell (A.Y. 2022-2023 to A.Y. 2019-20)"
        ]
    },
    {
        title: "Minority Cell",
        items: [
            "Members of Minority Cell",
            "Minutes of Meeting of Minority Cell (A.Y. 2025-26)",
            "Minutes of Meeting of Minority Cell (A.Y. 2023-24 to A.Y. 2024-25)",
            "Minutes of Meeting of Minority Cell (A.Y. 2022-23 to A.Y. 2019-20)",
        ],
    },
    {
        title: "Grievance Redressal Committee",
        items: [
            "Members of Grievance Redressal Committee",
            "Minutes of Meeting of Grievance Redressal Committee (November 25, 2025)",
            "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2025-26)",
            "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2023-2024 to A.Y. 2024-25)",
            "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2022-2023 to A.Y. 2017-18)"
        ],
    },
    {
        title: "Internal Complaint Committee",
        items: [
            "Members of Internal Complaint Committee",
            "Minutes of Meeting of Internal Complaint Committee (May 05, 2026)",
            "Minutes of Meeting of Internal Complaint Committee (A.Y. 2025-26)",
            "Minutes of Meeting of Internal Complaint Committee (A.Y. 2023-24 to A.Y. 2024-25)",
            "Minutes of Meeting of Internal Complaint Committee (A.Y. 2017-18 to A.Y. 2022-23)"
        ],
    },
    {
        title: "Anti-Ragging Committee",
        items: [
            "Members of Anti Ragging Committee",
            "Minutes of Meeting of Anti Ragging Committee (A.Y. 2025-26)",
            "Minutes of Meeting of Anti Ragging Committee (A.Y. 2023-24 to A.Y.2024-25)",
            "Minutes of Meeting of Anti Ragging Committee (A.Y. 2016-17 to A.Y.2022-23)"
        ],
    },
];

// PDF Paths Mapping (Replace these with your actual file paths)
// PDF Paths Mapping (Replace these with your actual file paths)
// PDF Paths Mapping (Replace these with your actual file paths)
const pdfPathMap = {
    "Notice of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/notice-25-26.pdf",

    "MOM of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/mom-25-26.pdf",

    "Notice and Circular of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2022-23 to A.Y. 2024-25)": "/pdf/about/CellsAndCommittes/notice-circular-22-25.pdf",

    "Minutes of Meeting of Advisory Committee for Equal Opportunity and SC / ST Committee (A.Y. 2022-23 to A.Y. 2024-25)": "/pdf/about/CellsAndCommittes/minutes-advisory-22-25.pdf",

    "Minutes of Meeting of Minority Cell (A.Y. 2022-2023 to A.Y. 2019-20)": "/pdf/about/CellsAndCommittes/minutes-minority-19-23.pdf",

    // --- MINORITY CELL PDF MAPPINGS ---
    "Minutes of Meeting of Minority Cell (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Minority Cell (A,Y. 2025-26).pdf",

    "Minutes of Meeting of Minority Cell (A.Y. 2023-24 to A.Y. 2024-25)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Minority Cell (A,Y. 2023-24 to A.Y. 2024-25).pdf",

    "Minutes of Meeting of Minority Cell (A.Y. 2022-23 to A.Y. 2019-20)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Minority Cell (A,Y. 2022-23 to A.Y. 2019-20).pdf",

    // --- NEW GRIEVANCE REDRESSAL PDF MAPPINGS ---
    // --- GRIEVANCE REDRESSAL PDF MAPPINGS ---

    "Minutes of Meeting of Grievance Redressal Committee (November 25, 2025)": "/pdf/about/CellsAndCommittes/GrievanceRedressalCOmmitte_MoM.pdf", "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Grievance Redressal Committee (A.Y. 2025-26).pdf",
    "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2023-2024 to A.Y. 2024-25)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Grievance Redressal Committee (A.Y. 2023-2024 to A.Y. 2024-25).pdf",
    "Minutes of Meeting of Grievance Redressal Committee (A.Y. 2022-2023 to A.Y. 2017-18)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Grievance Redressal Committee (A.Y. 2022-2023 to A.Y. 2017-18).pdf",
    // --- INTERNAL COMPLAINT COMMITTEE PDF MAPPINGS ---
    // --- INTERNAL COMPLAINT COMMITTEE PDF MAPPINGS ---
    "Minutes of Meeting of Internal Complaint Committee (May 05, 2026)": "/pdf/about/CellsAndCommittes/InternalComplaintCommitee_MoM.pdf",
    "Minutes of Meeting of Internal Complaint Committee (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Internal Complaint Committee (A.Y. 2025-26).pdf",

    "Minutes of Meeting of Internal Complaint Committee (A.Y. 2023-24 to A.Y. 2024-25)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Internal Complaint Committee A.Y. 2023-24 to A.Y. 2024-2025).pdf",

    "Minutes of Meeting of Internal Complaint Committee (A.Y. 2017-18 to A.Y. 2022-23)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Internal Complaint Committee A.Y. 2017-18 to A.Y.2022-2023).pdf",
    // --- ANTI RAGGING COMMITTEE PDF MAPPINGS ---
    "Minutes of Meeting of Anti Ragging Committee (A.Y. 2025-26)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Anti Ragging Committee (A.Y. 2025-26).pdf",

    "Minutes of Meeting of Anti Ragging Committee (A.Y. 2023-24 to A.Y.2024-25)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Anti Ragging Committee (A.Y. 2023-24 to A.Y.2024-25).pdf",

    "Minutes of Meeting of Anti Ragging Committee (A.Y. 2016-17 to A.Y.2022-23)": "/pdf/about/CellsAndCommittes/Minutes of Meeting of Anti Ragging Committee (A.Y. 2016-17 to A.Y.2022-23).pdf"
};
export default function AccordionCommittees() {
    const [showForm, setShowForm] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);
    const [selectedContent, setSelectedContent] = useState(
        "Advisory Committee for Equal Opportunity and SC / ST Committee"
    );
    const [selectedYear, setSelectedYear] = useState(
        Object.keys(advisoryCommitteeDataByYear)[0]
    );

    const toggleAccordion = (index) => {
        setActiveIndex((prev) => (prev === index ? null : index));
    };

    const getYearsForContent = (content) => {
        if (content === "Members of Minority Cell") {
            return Object.keys(minorityCellDataByYear);
        }
        if (content === "Members of Grievance Redressal Committee") {
            return Object.keys(grievanceCommitteeDataByYear);
        }
        if (content === "Members of Internal Complaint Committee") {
            return Object.keys(internalCompliantCommitteeDataByYear);
        }
        if (content === "Members of Anti Ragging Committee") {
            return Object.keys(antiRaggingCommitteeDataByYear);
        }
        return Object.keys(advisoryCommitteeDataByYear);
    };

    const handleItemClick = (item) => {
        setSelectedContent(item);
        const availableYears = getYearsForContent(item);
        if (availableYears.length && !availableYears.includes(selectedYear)) {
            setSelectedYear(availableYears[0]);
        }
    };

    // Helper function to render the year selector pills
    const renderYearSelector = (years) => (
        <div className="acp-year-container">
            {years.map((year) => (
                <button
                    key={year}
                    onClick={() => setSelectedYear(year)}
                    className={`acp-year-btn ${selectedYear === year ? "active" : ""}`}
                >
                    {year}
                </button>
            ))}
        </div>
    );

    const renderSelectedContent = () => {
        // --- 1. Check if the selected content is a PDF ---
        if (pdfPathMap[selectedContent]) {
            return (
                <div className="acp-card pdf-container">
                    <h3 className="governing-title">{selectedContent}</h3>
                    <iframe
                        src={pdfPathMap[selectedContent]}
                        width="100%"
                        height="800px" // Adjust height as necessary
                        title={selectedContent}
                        style={{ border: "none", borderRadius: "8px" }}
                    />
                </div>
            );
        }

        // --- 2. Otherwise, check for Member Tables ---
        if (selectedContent === "Members of Minority Cell") {
            const years = Object.keys(minorityCellDataByYear);
            return (
                <div className="acp-card Education-Policies-container common-section">
                    <h3 className="page-title governing-title">Members of Minority Cell</h3>
                    {renderYearSelector(years)}
                    <div className="acp-table-scroll">
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Name of the Official</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {minorityCellDataByYear[selectedYear].map((member) => (
                                    <tr key={member.no}>
                                        <td>{member.no}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        if (selectedContent === "Advisory Committee for Equal Opportunity and SC / ST Committee") {
            const years = Object.keys(advisoryCommitteeDataByYear);
            return (
                <div className="acp-card table-container">
                    <h3 className="governing-title">Members of SC / ST Committee</h3>
                    {renderYearSelector(years)}
                    <div className="acp-table-scroll">
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Name of the Official</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {advisoryCommitteeDataByYear[selectedYear].map((member) => (
                                    <tr key={member.no}>
                                        <td>{member.no}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        if (selectedContent === "Members of Grievance Redressal Committee") {
            const years = Object.keys(grievanceCommitteeDataByYear);
            return (
                <div className="acp-card table-container">
                    <h3 className="governing-title">Members of Grievance Redressal Committee</h3>
                    {renderYearSelector(years)}
                    <div className="acp-table-scroll">
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Position as per AICTE</th>
                                    <th>Member</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {grievanceCommitteeDataByYear[selectedYear].map((member) => (
                                    <tr key={member.no}>
                                        <td>{member.no}</td>
                                        <td>{member.position}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        if (selectedContent === "Members of Internal Complaint Committee") {
            const years = Object.keys(internalCompliantCommitteeDataByYear);
            return (
                <div className="acp-card table-container">
                    <h3 className="governing-title">Members of Internal Compliant Committee</h3>
                    {renderYearSelector(years)}
                    <div className="acp-table-scroll">
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Position as per AICTE</th>
                                    <th>Member</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(internalCompliantCommitteeDataByYear[selectedYear] || []).map((member) => (
                                    <tr key={member.no}>
                                        <td>{member.no}</td>
                                        <td>{member.position}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        if (selectedContent === "Members of Anti Ragging Committee") {
            const years = Object.keys(antiRaggingCommitteeDataByYear);
            return (
                <div className="acp-card table-container">
                    <h3 className="governing-title">Members of Anti Ragging Committee</h3>
                    {renderYearSelector(years)}
                    <div className="acp-table-scroll">
                        <table className="responsive-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Position as per AICTE</th>
                                    <th>Member</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(antiRaggingCommitteeDataByYear[selectedYear] || []).map((member) => (
                                    <tr key={member.no}>
                                        <td>{member.no}</td>
                                        <td>{member.position}</td>
                                        <td>{member.name}</td>
                                        <td>{member.designation}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        // --- 3. Default fallback ---
        return <div className="acp-card"><p>{selectedContent}</p></div>;
    };

    return (
        <>
            <Navbar setShowForm={setShowForm} />
            {showForm && <BrochureForm setShowForm={setShowForm} />}
            <CTAButtons />
            <PageHeader
                title="Cells and Committees"
                crumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Cells and Committees' },
                ]}
            />
            <div className="acp-dashboard-layout">
                {/* Modern Sidebar Accordion */}
                <div className="acp-sidebar">
                    {committeeData.map((section, index) => (
                        <div key={index} className="acp-accordion-section">
                            <button
                                className={`acp-accordion-title ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                <span className="acp-title-text">
                                    <span className="acp-icon-placeholder"></span>
                                    {section.title}
                                </span>
                                <span className="acp-chevron">
                                    {activeIndex === index ? "⌃" : "⌄"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="acp-accordion-content">
                                    {section.items.map((item, idx) => (
                                        <div
                                            key={idx}
                                            className={`acp-inner-item ${selectedContent === item ? "active" : ""}`}
                                            onClick={() => handleItemClick(item)}
                                        >
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Main Dynamic Panel */}
                <div className="acp-main-panel">
                    {renderSelectedContent()}
                </div>
            </div>
            <Footer />
        </>
    );
}